module.exports = "/images/marker-company.png?5d3b2c79e0718e37a0019b69e3955989";